'use es6';

import { Record } from 'immutable';
const WidgetUi = Record({
  isFullscreen: false,
  mobile: false,
  open: false,
  hideWelcomeMessage: false,
  domain: null,
  startOpen: undefined,
  url: null,
  userInteractedWithWidget: false,
  isEmbeddedInProduct: false,
  mode: null,
  isAttachmentDisabled: false,
  isInitialInputFocusDisabled: false,
  apiEnableWidgetCookieBanner: false,
  isInCMS: false,
  hideScrollToButton: true,
  isIOSMobile: false
}, 'WidgetUi');
export default WidgetUi;